import * as bidders from './hbBidders';
import * as sizes from './hbSizes';

export enum Collapse {
    NEVER,
    AFTER_FETCH,
    BEFORE_FETCH,
}

export interface AdUnitDefinition {
    201?: {
        gptid: string;
        bids: any[];
    };
    202?: {
        gptid: string;
        bids: any[];
    };
    207?: {
        gptid: string;
        bids: any[];
    };

    sizeMapping: sizes.SizeMapping;
    collapse?: Collapse;
}

export interface AdUnitDefinitions {
    [adUnitName: string]: AdUnitDefinition;
}

export const forum: AdUnitDefinitions = {
    'Forum - Branding (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-branding2',
            bids: [
                bidders.adform.brandingDesktopSK,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding2',
            bids: [
                bidders.adform.brandingDesktopCZ,
            ],
        },

        sizeMapping: sizes.brandingDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Forum - Branding (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-branding9',
            bids: [
                bidders.adform.brandingMobileSK,
                // bidders.im.brandingMobileSK_NT,
                // bidders.im.brandingMobileSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding9',
            bids: [
                bidders.adform.brandingMobileCZ,
                // bidders.im.brandingMobileCZ_NT,
                // bidders.im.brandingMobileCZ_TT,
            ],
        },

        sizeMapping: sizes.brandingMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Forum - Branding Dni s (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-branding7',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-branding7',
            bids: [],
        },

        sizeMapping: sizes.brandingDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Forum - Branding Dni s (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-branding14',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-branding14',
            bids: [],
        },

        sizeMapping: sizes.brandingMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Forum - Branding Sutaz (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-branding15',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-branding15',
            bids: [],
        },

        sizeMapping: sizes.brandingDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Forum - Branding Sutaz (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-branding16',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-branding16',
            bids: [],
        },

        sizeMapping: sizes.brandingMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    // sticky zona musi byt specialne oznacena v AdX, aby neporusovala podmienky
    'Forum Thread - Halfpage Sticky (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-halfpage2',
            bids: [
                bidders.adform.halfpageSK,
                // bidders.appnexus.halfpageSK, bidders.admeta.halfpageSK
                // bidders.im.halfpageSK_NT,
                // bidders.im.halfpageSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-halfpage2',
            bids: [
                bidders.adform.halfpageCZ,
                // bidders.appnexus.halfpageCZ, bidders.admeta.halfpageCZ
                // bidders.im.halfpageCZ_NT,
                // bidders.im.halfpageCZ_TT,
            ],
        },

        sizeMapping: sizes.halfpage,
    },

    'Forum Thread - Halfpage (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-halfpage9',
            bids: [
                bidders.adform.halfpageSK,
                // bidders.appnexus.halfpageSK, bidders.admeta.halfpageSK
                // bidders.im.halfpageSK_NT,
                // bidders.im.halfpageSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-halfpage9',
            bids: [
                bidders.adform.halfpageCZ,
                // bidders.appnexus.halfpageCZ, bidders.admeta.halfpageCZ
                // bidders.im.halfpageCZ_NT,
                // bidders.im.halfpageCZ_TT,
            ],
        },

        sizeMapping: sizes.halfpageMobileOnly,
    },

    'Forum Thread - Rectangle 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle7',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle7',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Forum Thread - Rectangle 2 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle8',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle8',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Forum Thread - Rectangle 3 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle9',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle9',
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
    },

    'Forum Thread - Rectangle 4 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle10',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle10',
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
    },

    'Forum Category - Rectangle 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle14',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle14',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
    },

    'Forum Category - Rectangle 2 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle15',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle15',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
    },

    // sticky zona musi byt specialne oznacena v AdX, aby neporusovala podmienky
    'Forum Category - Halfpage Sticky (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-halfpage5',
            bids: [
                bidders.adform.halfpageSK,
                // bidders.im.halfpageSK_NT,
                // bidders.im.halfpageSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-halfpage5',
            bids: [
                bidders.adform.halfpageCZ,
                // bidders.im.halfpageCZ_NT,
                // bidders.im.halfpageCZ_TT,
            ],
        },

        sizeMapping: sizes.halfpage,
    },

};

export const groups: AdUnitDefinitions = {
    'Groups - Branding (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-branding4',
            bids: [
                bidders.adform.brandingDesktopSK,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding4',
            bids: [
                bidders.adform.brandingDesktopCZ,
            ],
        },

        sizeMapping: sizes.brandingDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Groups - Branding (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-branding11',
            bids: [
                bidders.adform.brandingMobileSK,
                // bidders.im.brandingMobileSK_NT,
                // bidders.im.brandingMobileSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding11',
            bids: [
                bidders.adform.brandingMobileCZ,
                // bidders.im.brandingMobileCZ_NT,
                // bidders.im.brandingMobileCZ_TT,
            ],
        },

        sizeMapping: sizes.brandingMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Groups Feed - Halfpage Sticky (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-halfpage3',
            bids: [
                bidders.adform.halfpageSK,
                // bidders.appnexus.halfpageSK, bidders.admeta.halfpageSK
                // bidders.im.halfpageSK_NT,
                // bidders.im.halfpageSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-halfpage3',
            bids: [
                bidders.adform.halfpageCZ,
                // bidders.appnexus.halfpageCZ, bidders.admeta.halfpageCZ
                // bidders.im.halfpageCZ_NT,
                // bidders.im.halfpageCZ_TT,
            ],
        },

        sizeMapping: sizes.halfpage,
    },

    'Groups Feed - Rectangle 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle20',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle20',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Groups Feed - Rectangle 2 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle21',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle21',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Groups Feed - Rectangle 3 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle22',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle22',
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
    },

    'Groups Feed - Rectangle 4 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle23',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle23',
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
    },
};

export const blogs: AdUnitDefinitions = {
    'Blogs - Branding (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-branding3',
            bids: [
                bidders.adform.brandingDesktopSK,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding3',
            bids: [
                bidders.adform.brandingDesktopCZ,
            ],
        },

        sizeMapping: sizes.brandingDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Blogs - Branding (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-branding10',
            bids: [
                bidders.adform.brandingMobileSK,
                // bidders.im.brandingMobileSK_NT,
                // bidders.im.brandingMobileSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding10',
            bids: [
                bidders.adform.brandingMobileCZ,
                // bidders.im.brandingMobileCZ_NT,
                // bidders.im.brandingMobileCZ_TT,
            ],
        },

        sizeMapping: sizes.brandingMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Blogs Feed - Halfpage Sticky (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-halfpage4',
            bids: [
                bidders.adform.halfpageSK,
                // bidders.appnexus.halfpageSK, bidders.admeta.halfpageSK
                // bidders.im.halfpageSK_NT,
                // bidders.im.halfpageSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-halfpage4',
            bids: [
                bidders.adform.halfpageCZ,
                // bidders.appnexus.halfpageCZ, bidders.admeta.halfpageCZ
                // bidders.im.halfpageCZ_NT,
                // bidders.im.halfpageCZ_TT,
            ],
        },

        sizeMapping: sizes.halfpage,
    },

    'Blogs Feed - Rectangle 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle16',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle16',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Blogs Feed - Rectangle 2 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle17',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle17',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Blogs Feed - Rectangle 3 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle18',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle18',
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
    },

    'Blogs Feed - Rectangle 4 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle19',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle19',
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
    },

    // sticky zona musi byt specialne oznacena v AdX, aby neporusovala podmienky
    'Blogs Article - Halfpage Sticky (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-halfpage7',
            bids: [
                bidders.adform.halfpageSK,
                // bidders.im.halfpageSK_NT,
                // bidders.im.halfpageSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-halfpage7',
            bids: [
                bidders.adform.halfpageCZ,
                // bidders.im.halfpageCZ_NT,
                // bidders.im.halfpageCZ_TT,
            ],
        },

        sizeMapping: sizes.halfpageOffsite,
    },

    'Blogs Article - Rectangle 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle11',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle11',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
    },

    'Blogs Article - Rectangle 2 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle12',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle12',
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
    },

    'Blogs Article - Rectangle 3 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle13',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle13',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
    },

    'Blogs Article - Rectangle 4 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle26',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle26',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
    },

    'Blogs Article - Billboard 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-billboard5',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-billboard5',
            bids: [
                // bidders.criteo.rectangleCZ,
            ],
        },

        sizeMapping: sizes.billboard,
        collapse: Collapse.AFTER_FETCH,
    },

    'Blogs Article - Text ad 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-text1',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-text1',
            bids: [
                // bidders.criteo.rectangleCZ,
            ],
        },

        sizeMapping: sizes.text,
        collapse: Collapse.AFTER_FETCH,
    },
};

export const market: AdUnitDefinitions = {
    'Market - Branding (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-branding5',
            bids: [
                bidders.adform.brandingDesktopSK,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding5',
            bids: [
                bidders.adform.brandingDesktopCZ,
            ],
        },

        sizeMapping: sizes.brandingDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Market - Branding (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-branding12',
            bids: [
                bidders.adform.brandingMobileSK,
                // bidders.im.brandingMobileSK_NT,
                // bidders.im.brandingMobileSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding12',
            bids: [
                bidders.adform.brandingMobileCZ,
                // bidders.im.brandingMobileCZ_NT,
                // bidders.im.brandingMobileCZ_TT,
            ],
        },

        sizeMapping: sizes.brandingMobileOnly,
        collapse: Collapse.BEFORE_FETCH,
    },

    // sticky zona musi byt specialne oznacena v AdX, aby neporusovala podmienky
    'Market Item - Halfpage Sticky (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-halfpage1',
            bids: [
                bidders.adform.halfpageSK,
                // bidders.appnexus.halfpageSK, bidders.admeta.halfpageSK
                // bidders.im.halfpageSK_NT,
                // bidders.im.halfpageSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-halfpage1',
            bids: [
                bidders.adform.halfpageCZ,
                // bidders.appnexus.halfpageCZ, bidders.admeta.halfpageCZ
                // bidders.im.halfpageCZ_NT,
                // bidders.im.halfpageCZ_TT,
            ],
        },

        sizeMapping: sizes.halfpageOffsite,
    },

    // CeMi: 14.6.2017 - vypnuty, generuje len 250Eur mesacne, a kazi nizkym CTR priame kampane
    // 'Market Item - Billboard (Desktop)': {
    //     201: {
    //         gptid: '/10813505/mk.sk-billboard1',
    //         bids: [bidders.adform.billboardSK],
    //     },
    //     202: {
    //         gptid: '/10813505/mk.cz-billboard1',
    //         bids: [bidders.adform.billboardCZ],
    //     },
    //
    //     sizeMapping: sizes.billboard,
    // },

    'Market Item - Rectangle 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle4',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle4',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Market Item - Rectangle 2 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle5',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle5',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Market Item - Rectangle 3 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle6',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle6',
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
    },

    'Market Section - Billboard 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-billboard2',
            bids: [
                bidders.adform.billboardSK,
                // bidders.im.billboardSK_NT,
                // bidders.im.billboardSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-billboard2',
            bids: [
                bidders.adform.billboardCZ,
                // bidders.im.billboardCZ_NT,
                // bidders.im.billboardCZ_TT,
            ],
        },

        sizeMapping: sizes.billboard,
        collapse: Collapse.AFTER_FETCH,
    },

    'Market Section - Billboard 2 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-billboard3',
            // bids: [bidders.appnexus.billboardSK, bidders.admeta.billboardSK],
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-billboard3',
            // bids: [bidders.appnexus.billboardCZ, bidders.admeta.billboardCZ],
            bids: [
            ],
        },

        sizeMapping: sizes.billboard,
    },

    'Market Section - Rectangle 1 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle1',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle1',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Market Section - Rectangle 2 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle2',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle2',
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
    },

    'Market Section - Rectangle 3 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle3',
            // bids: [bidders.appnexus.rectangleSK, bidders.admeta.rectangleSK],
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle3',
            // bids: [bidders.appnexus.rectangleCZ, bidders.admeta.rectangleCZ],
            bids: [
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
    },
};

export const wiki: AdUnitDefinitions = {
    'Wiki - Branding (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-branding6',
            bids: [
                bidders.adform.brandingDesktopSK,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding6',
            bids: [
                bidders.adform.brandingDesktopCZ,
            ],
        },

        sizeMapping: sizes.brandingDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Wiki - Branding (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-branding13',
            bids: [
                bidders.adform.brandingMobileSK,
                // bidders.im.brandingMobileSK_NT,
                // bidders.im.brandingMobileSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding13',
            bids: [
                bidders.adform.brandingMobileCZ,
                // bidders.im.brandingMobileCZ_NT,
                // bidders.im.brandingMobileCZ_TT,
            ],
        },

        sizeMapping: sizes.brandingMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    // sticky zona musi byt specialne oznacena v AdX, aby neporusovala podmienky
    'Wiki - Halfpage Sticky (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-halfpage8',
            bids: [
                bidders.adform.halfpageSK,
                // bidders.im.halfpageSK_NT,
                // bidders.im.halfpageSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-halfpage8',
            bids: [
                bidders.adform.halfpageCZ,
                // bidders.im.halfpageCZ_NT,
                // bidders.im.halfpageCZ_TT,
            ],
        },

        sizeMapping: sizes.halfpage,
    },
};

export const homepage: AdUnitDefinitions = {
    'Homepage - Branding (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-branding1',
            bids: [
                bidders.adform.brandingDesktopSK,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding1',
            bids: [
                bidders.adform.brandingDesktopCZ,
            ],
        },

        sizeMapping: sizes.brandingDesktopOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Homepage - Branding (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-branding8',
            bids: [
                bidders.adform.brandingMobileSK,
                // bidders.im.brandingMobileSK_NT,
                // bidders.im.brandingMobileSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-branding8',
            bids: [
                bidders.adform.brandingMobileCZ,
                // bidders.im.brandingMobileCZ_NT,
                // bidders.im.brandingMobileCZ_TT,
            ],
        },

        sizeMapping: sizes.brandingMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },

    'Homepage - Rectangle 1 (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle24',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle24',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleDesktopOnly,
        collapse: Collapse.NEVER,
    },

    'Homepage - Rectangle 2 (Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-rectangle25',
            bids: [
                bidders.adform.rectangleSK,
                // bidders.criteo.rectangleSK,
                // bidders.im.rectangleSK_NT,
                // bidders.im.rectangleSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-rectangle25',
            bids: [
                bidders.adform.rectangleCZ,
                // bidders.criteo.rectangleCZ,
                // bidders.im.rectangleCZ_NT,
                // bidders.im.rectangleCZ_TT,
            ],
        },

        sizeMapping: sizes.rectangleMobileOnly,
        collapse: Collapse.AFTER_FETCH,
    },
};

export const mail: AdUnitDefinitions = {
    'Mail - Commercial (Desktop & Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-ip1',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-ip1',
            bids: [],
        },

        sizeMapping: sizes.mail,
        collapse: Collapse.NEVER,
    },
};

export const mailCtaButton: AdUnitDefinitions = {
    'Mail - CTA Button (Desktop & Mobile)': {
        201: {
            gptid: '/10813505/mk.sk-ip3',
            bids: [],
        },
        202: {
            gptid: '/10813505/mk.cz-ip3',
            bids: [],
        },

        sizeMapping: sizes.mailCtaButton,
        collapse: Collapse.NEVER,
    },
};

export const strollers: AdUnitDefinitions = {
    'Strollers Index - Halfpage Sticky (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-halfpage6',
            bids: [
                bidders.adform.halfpageSK,
                // bidders.appnexus.halfpageSK, bidders.admeta.halfpageSK
                // bidders.im.halfpageSK_NT,
                // bidders.im.halfpageSK_TT,
            ],
        },
        202: {
            gptid: '/10813505/mk.cz-halfpage6',
            bids: [
                bidders.adform.halfpageCZ,
                // bidders.appnexus.halfpageCZ, bidders.admeta.halfpageCZ
                // bidders.im.halfpageCZ_NT,
                // bidders.im.halfpageCZ_TT,
            ],
        },
        207: {
            gptid: '/10813505/sb.com-halfpage6',
            bids: [],
        },

        sizeMapping: sizes.halfpage,
    },
};

export const test: AdUnitDefinitions = {
    'Test - Billboard (Desktop)': {
        201: {
            gptid: '/10813505/mk.sk-billboard4',
            bids: [bidders.test.billboardSK],
        },
        202: {
            gptid: '/10813505/mk.cz-billboard4',
            bids: [],
        },

        sizeMapping: sizes.billboard,
    },
};

export const all: AdUnitDefinitions = {
    ...homepage,
    ...forum,
    ...groups,
    ...blogs,
    ...market,
    ...wiki,
    ...mail,
    ...mailCtaButton,
    ...strollers,
    ...test,
};

export function isBrandingDesktopAdUnit(code: string) {
    return code.endsWith('branding-desktop')
        || code.endsWith('branding-dni-s-desktop')
        || code.endsWith('branding-sutaz-desktop');
}

export function isMailAdUnit(code: string) {
    return code === 'slot-mail-commercial-desktop-mobile' || code === 'slot-mail-cta-button-desktop-mobile';
}
